<template>
	<div class="field_mapping_item mapping-row">
		<div class="field_mapping_col">
			<v-select
					class="grouped small"
					label="text"
					:options="localSources"
					autocomplete="sdfcxc"
					v-model="row.src"
					@input="selectChanged"
					:reduce="x => x.id"
					:selectable="option => !option.hasOwnProperty('group') && ! option.disabled"
					append-to-body>
				<template #option="{ text, id, group }">
					<span class="select-option" :class="{group}">{{ text }}</span>
				</template>
				<template #selected-option="{ text, id }">
					<v-spinner v-if="loadingSources" />
					<span v-else class="select-option">{{ text }}</span>
				</template>
			</v-select>
		</div>
		<span class="field_mapping_arrow">
        <inline-svg :src="require('@/assets/img/field_mapping_arrow.svg')"/>
    </span>
		<div class="field_mapping_col">
			<v-select
					class="grouped small"
					label="text"
					:options="localTargets"
					v-model="row.target"
					autocomplete="sdfdfdf"
					:reduce="x => x.id"
					@input="targetChanged"
					:selectable="option => !option.disabled"
					append-to-body>
				<template #option="{ text, id, group }">
          <span class="select-option" :class="{group}">
              {{id}}
              <span class="option-column" v-if="text">[{{ text }}]</span>
          </span>
				</template>
				<template #selected-option="{ text, id }">
          <span class="select-option">
              {{id}}
              <span class="option-column" v-if="text">[{{ text }}]</span>
          </span>
				</template>
			</v-select>
		</div>
		<a @click="removeMappingItem" class="panel_item_btn delete_btn">
			<inline-svg :src="require('@/assets/img/popup_close.svg')"/>
		</a>
	</div>
</template>

<script>
import VSpinner from "@/components/base/v-spinner";
export default {
	name: "mapping-row",
	components: {VSpinner}, props: ["sources", "targets", "mappings", "row", "originalTargets", "originalSources",'loadingSources'],

	data() {
		return {

		}
	},
	computed:{
		localTargets() {
			if (!this.row) return this.targets;

			let r = this.originalTargets.find(x=>x.id===this.row.target)
			if (!r) return this.targets;
			return [r,...this.targets]
		},
		localSources() {
			if (!this.row) return this.sources;

			let r = this.originalSources.find(x=>x.id===this.row.src)
			if (!r) return this.sources;
			return [r,...this.sources]
		}
	},

	methods: {
		removeMappingItem() {
			this.$emit('removeRow', this.row);
		},
		selectChanged(val) {
			this.$emit('updateMapping', this.row);
		},
		targetChanged(val) {
			this.$emit('updateMapping', this.row);
		},
	}
}
</script>

<style lang="scss" scoped>
.mapping-row {

}
</style>
